/**
 * Leave /sign-in once the session exists, replacing its history entry so Back
 * from the wizard never lands on the sign-in page and bounces forward again
 * (ob-09 U14). An object so jsdom suites can observe the call.
 */
export const postSignInRedirect = {
  go(path: string = '/') {
    window.location.replace(path)
  },
}
